<template>
  <v-autocomplete
    :items="items"
    :label="prop.text"
    v-model="selected"
    browser-autocomplete
    return-object
    :readonly="readonly"
    :clearable="!readonly"
    :item-text="prop.sourceItemText"
    :item-value="prop.sourceItemValue"
    counter
    :loading="loading"
    :multiple="prop.multiple"
    :name="prop.text"
    :error-messages="error"
    @click:clear="clearValue"
  >
    <template v-slot:append-outer>
      <v-btn color="secondary" flat icon small @click="refresh">
        <v-icon small>cached</v-icon>
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<style scoped></style>

<script>
  import SelectionInput from "./selectionInput.ts";
  export default SelectionInput;
</script>
